/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Facet} from "../facets/facet"
import {SUBREAD_FRAME, PARENT_SUBREAD_FRAME, CHILD_SUBREAD_FRAME, FLATTENED_SUBREAD_FRAME} from "../frames/subread"
import { multisort, desc, valueToDate } from "../../core/utils/property-sort"

export const SUBREAD_FACET = new Facet({
    frame: SUBREAD_FRAME,
    multiSelect: true,
    defaultColumns: [
        "name", "numChildren", "wellSampleName", "bioSampleName", "dnaBarcodeName", "runName", "createdAt", "createdBy"],
    initialSort: multisort(desc(valueToDate("updatedAt")), desc(valueToDate("createdAt"))),
    additionalColumns: [
        "id", "cellId", "cellIndex", "totalLength",  "instrumentName", "wellName",
        "jobId", "uuid", "path", "updatedAt",
        "tags", "projectId", "version", "md5", "comments",
        "numRecords", "metadataContextId"],
    displayProperties: [
        "name", "runName", "cellIndex","numRecords", "totalLength",
        "createdAt", "instrumentName", "wellName", "wellSampleName",
        "bioSampleName", "plateId", "jobId", "id", "uuid", "path", "updatedAt",
        "tags", "projectId", "version", "md5", "createdBy", "comments",
        "metadataContextId"]
})

export const CHILD_SUBREAD_FACET = Object.assign({}, SUBREAD_FACET)
CHILD_SUBREAD_FACET.defaultColumns =
    ["name", "wellSampleName", "bioSampleName", "dnaBarcodeName", "runName", "createdAt", "createdBy"]
CHILD_SUBREAD_FACET.frame = CHILD_SUBREAD_FRAME

export const PARENT_SUBREAD_FACET = Object.assign({}, SUBREAD_FACET)
PARENT_SUBREAD_FACET.frame = PARENT_SUBREAD_FRAME

export const FLATTENED_SUBREAD_FACET = Object.assign({}, SUBREAD_FACET)
FLATTENED_SUBREAD_FACET.defaultColumns = FLATTENED_SUBREAD_FACET.defaultColumns.filter( col => col !== "numChildren")
FLATTENED_SUBREAD_FACET.frame = FLATTENED_SUBREAD_FRAME

export const SUBREAD_FACET_WITHOUT_CHILD_COL = Object.assign({}, SUBREAD_FACET)
SUBREAD_FACET_WITHOUT_CHILD_COL.defaultColumns =
    SUBREAD_FACET_WITHOUT_CHILD_COL.defaultColumns.filter( col => col !== "numChildren")





